import FilePreviewHandler from './FilePreviewHandler-redux';

export default FilePreviewHandler;
